module.exports = __webpack_public_path__ + "img/logo.a0b9d04e.png";